async function handleJobFormSubmit() {
    // Raccogli i valori dei campi dal form
    const firstname = document.getElementById('firstname').value.trim();
    const lastname = document.getElementById('lastname').value.trim();
    const birthYear = document.getElementById('birthYear').value.trim();
    const address = document.getElementById('address').value.trim();
    const phoneNumber = document.getElementById('phoneNumber').value.trim();
    const email = document.getElementById('email').value.trim();
    const vehicleType = document.getElementById('vehicleType').value;
    const drivingLicense = document.getElementById('drivingLicense').value;
    const workingCity = document.getElementById('workingCity').value;
    const availability = document.getElementById('availability').value;
    const message = document.getElementById('message').value.trim();
    const privacyPolicyAccepted = document.getElementById('privacyPolicy').checked;

    let hasError = false;

    // Validazione dei campi
    if (!firstname) {
        document.getElementById('error-firstname').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-firstname').classList.add('d-none');
    }

    if (!lastname) {
        document.getElementById('error-lastname').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-lastname').classList.add('d-none');
    }

    if (!birthYear) {
        document.getElementById('error-birthYear').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-birthYear').classList.add('d-none');
    }

    if (!address) {
        document.getElementById('error-address').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-address').classList.add('d-none');
    }

    if (!phoneNumber) {
        document.getElementById('error-phoneNumber').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-phoneNumber').classList.add('d-none');
    }

    if (!email) {
        document.getElementById('error-email').classList.remove('d-none');
        document.getElementById('invalid-email').classList.add('d-none');
        hasError = true;
    } else if (!isEmailValid(email)) {
        document.getElementById('error-email').classList.add('d-none');
        document.getElementById('invalid-email').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-email').classList.add('d-none');
        document.getElementById('invalid-email').classList.add('d-none');
    }

    if (!vehicleType) {
        document.getElementById('error-vehicleType').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-vehicleType').classList.add('d-none');
    }

    if (!drivingLicense) {
        document.getElementById('error-drivingLicense').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-drivingLicense').classList.add('d-none');
    }

    if (!workingCity) {
        document.getElementById('error-workingCity').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-workingCity').classList.add('d-none');
    }

    if (!availability) {
        document.getElementById('error-availability').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-availability').classList.add('d-none');
    }

    if (!privacyPolicyAccepted) {
        document.getElementById('error-privacyPolicy').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-privacyPolicy').classList.add('d-none');
    }

    // Se ci sono errori, interrompi l'invio
    if (hasError) {
        return;
    }

    try {
        // Mostra un loader se necessario
        // showLoader(true);

        // Chiama la funzione per inviare l'email
        const response = await sendJobEmailForAcademy('Candidatura Washer', // Subject
            workingCity, vehicleType, birthYear, address, drivingLicense, availability, message, // Il messaggio può essere vuoto
            firstname, lastname, email, phoneNumber, 'it-IT' // EmailLanguageCode (Italian)
        );

        // Nascondi il loader se lo stai utilizzando
        // showLoader(false);

        console.log(response);

        // Controlla se la risposta contiene success: true
        if (response.success === true) {
            document.getElementById('jobApplicationForm').reset(); // Resetta il form
            // Mostra il messaggio di successo
            document.getElementById('success-alert').classList.remove('d-none');
            setTimeout(() => {
                document.getElementById('success-alert').classList.add('d-none');
            }, 5000);
        } else {
            // Mostra il messaggio di errore
            document.getElementById('error-alert').classList.remove('d-none');
            setTimeout(() => {
                document.getElementById('error-alert').classList.add('d-none');
            }, 5000);
        }
    } catch (error) {
        console.error(error);
        // Nascondi il loader in caso di errore
        // showLoader(false);
        // Mostra il messaggio di errore
        document.getElementById('error-alert').classList.remove('d-none');
        setTimeout(() => {
            document.getElementById('error-alert').classList.add('d-none');
        }, 5000);
    }
}

async function handleFormSubmit() {
    // Capture form inputs
    const fullName = document.getElementById('name').value.trim();
    const email = document.getElementById('email').value.trim();
    const phoneNumber = document.getElementById('number').value.trim();
    const message = document.getElementById('message').value.trim();
    const privacyPolicyAccepted = document.getElementById('privacyPolicy').checked;


    let hasError = false;

    // Input validation for Full Name
    if (!fullName) {
        document.getElementById('error-name').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-name').classList.add('d-none');
    }

    // Input validation for Email
    if (!email) {
        document.getElementById('error-email').classList.remove('d-none');
        document.getElementById('invalid-email').classList.add('d-none');
        hasError = true;
    } else if (!isEmailValid(email)) {
        document.getElementById('error-email').classList.add('d-none');
        document.getElementById('invalid-email').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-email').classList.add('d-none');
        document.getElementById('invalid-email').classList.add('d-none');
    }

    // Input validation for Phone Number
    if (!phoneNumber) {
        document.getElementById('error-number').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-number').classList.add('d-none');
    }

    // Input validation for Message
    if (!message) {
        document.getElementById('error-message').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-message').classList.add('d-none');
    }

    if (!privacyPolicyAccepted) {
        document.getElementById('error-privacyPolicy').classList.remove('d-none');
        hasError = true;
    } else {
        document.getElementById('error-privacyPolicy').classList.add('d-none');
    }

    // If there are validation errors, do not proceed
    if (hasError) {
        return;
    }

    try {
        console.log('Sending support email...');

        // Show loader if you have one
        // showLoader(true);

        // Call the function with appropriate parameters
        const response = await formSupportSubmit('Support Request',   // Subject
            message,             // Message
            fullName,            // FullName
            email,               // Email
            phoneNumber,         // PhoneNumber
            'it-IT'              // EmailLanguageCode (Italian)
        );

        // Nascondi il loader se lo stai utilizzando
        // showLoader(false);

        console.log(response);

        // Controlla se la risposta contiene success: true
        if (response.success === true) {
            document.getElementById('supportForm').reset(); // Clear the form
            // Show the success alert
            document.getElementById('success-alert').classList.remove('d-none');
            // Hide the alert after 5 seconds
            setTimeout(() => {
                document.getElementById('success-alert').classList.add('d-none');
            }, 5000);
        } else {
            // Show the error alert
            document.getElementById('error-alert').classList.remove('d-none');
            setTimeout(() => {
                document.getElementById('error-alert').classList.add('d-none');
            }, 5000);
        }
    } catch (error) {
        console.error(error);
        // Hide loader in case of error
        // showLoader(false);
        // Show the error alert
        document.getElementById('error-alert').classList.remove('d-none');
        setTimeout(() => {
            document.getElementById('error-alert').classList.add('d-none');
        }, 5000);
    }
}

function toggleSubmitButton(checkboxId, submitButtonId) {
    const checkbox = document.getElementById(checkboxId);
    const submitButton = document.getElementById(submitButtonId);

    if (checkbox.checked) {
        submitButton.disabled = false;
    } else {
        submitButton.disabled = true;
    }
}